import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { MantineProvider, createTheme, type MantineColorsTuple } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './contexts/AuthProvider';
import { EnvBadge } from './modules/system/EnvBadge';

import './styles/design/index.css';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';

// Mantine DateInput парсит ручной ввод через dayjs(val, valueFormat, locale).
// Без customParseFormat dayjs игнорирует формат и читает ДД.ММ.ГГГГ как ММ.ДД.ГГГГ.
dayjs.extend(customParseFormat);

const brand: MantineColorsTuple = [
  '#fdf4f6',
  '#fce8ec',
  '#f5d0d9',
  '#e5b4c0',
  '#d4849a',
  '#c97288',
  '#7A1028',
  '#62101f',
  '#5c0c1e',
  '#4d0a19',
];

const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { light: 6, dark: 6 },
  colors: {
    brand,
  },
  components: {
    Modal: {
      defaultProps: {
        closeOnClickOutside: false,
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <Notifications />
        <BrowserRouter>
          <AuthProvider>
            <App />
            <EnvBadge />
          </AuthProvider>
        </BrowserRouter>
      </ModalsProvider>
    </MantineProvider>
  </StrictMode>
);